import { render, staticRenderFns } from "./PageStoriesArchive.vue?vue&type=template&id=cf060f32&"
import script from "./PageStoriesArchive.vue?vue&type=script&lang=ts&"
export * from "./PageStoriesArchive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports